import React from 'react'
import { connect } from 'react-redux'
import Profile from 'Participant/Profile/Profile'
import { updateProfile, expireUpdatedParticipant } from 'Participant/ducks'

const mapStateToProps = ({ participant }) => ({ participant })

const mapDispatchToProps = dispatch => ({
  updateParticipant: participant => dispatch(updateProfile(participant)),
  expireUpdatedParticipant: () => dispatch(expireUpdatedParticipant())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Profile {...props} />)



// WEBPACK FOOTER //
// ./src/Participant/Profile/ProfilePage.js